import Main from './OrdersMain'
import Show from './OrdersShow'

const Orders = {
  Main,
  Show,
}

export default Orders
